<template>
  <div class="nx-relation-group-card mb-3 nx-primary--lighten-5 empty">
    <v-layout column class="py-4 empty justify-center align-center">
      <v-icon large color="primary">cancel</v-icon>
      <span class="d-block caption nx-heading--level-4 mt-1" v-html="$t('message.entity.list.empty')"></span>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'nx-entity-list-editor-item-empty',
};
</script>

<style lang="stylus">
.nx-relation-group-card {
  transition: all .5s;
  will-change: transform;
}
</style>
